import PropTypes from "prop-types"
import { Tag } from "antd"
import styles from "./BookingTag.module.css"

const BookingTag = ({ color, children, className }) => (
  <Tag
    color={color}
    variant="filled"
    className={`${styles.tag} ${className || ""}`}
  >
    {children}
  </Tag>
)

BookingTag.propTypes = {
  color: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

export default BookingTag
